import {useCallback} from "react";

export const useDeviceUUID = () => {
    const getDeviceUUID = useCallback(() => {
        return document.cookie.replace(
            /(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/,
            "$1"
        );
    }, []);

    return {getDeviceUUID};
};
